import { resolveFunnelI18n } from '../../funnels/i18nOverrides';

export default defineNuxtPlugin((nuxtApp) => {
  const overrides = resolveFunnelI18n(useFunnelContext().value);
  const i18n = nuxtApp.$i18n as { mergeLocaleMessage?: (locale: string, messages: Record<string, string>) => void } | undefined;

  if (!i18n?.mergeLocaleMessage) return;

  for (const [locale, messages] of Object.entries(overrides)) {
    i18n.mergeLocaleMessage(locale, messages);
  }
});
